// extracted by mini-css-extract-plugin
module.exports =  {"icon":"GlmNYyj0roLoTsfXigNh"};